/***
 *
 *   NAMES
 *   Display helpers for people shown in ticket history.
 *
 *   History rows store `creator_name` as a pre-built string. Rows synced from
 *   ClickUp before the server fix read "ClickBot null" / "X undefined", so the
 *   stray tokens are stripped at display time rather than migrated.
 *
 **********/

const EMPTY_TOKENS = new Set(['null', 'undefined']);

const clean = (value) =>
    String(value ?? '')
        .split(/\s+/)
        .filter((part) => part && !EMPTY_TOKENS.has(part.toLowerCase()))
        .join(' ');

/** Full name from a string or a { first_name, last_name } object. */
export function displayName(target) {
    if (!target) return '';
    if (typeof target === 'object') {
        return clean(`${target.first_name ?? ''} ${target.last_name ?? ''}`) || clean(target.full_name);
    }
    return clean(target);
}

/**
 * Whether `target` (history author) is the signed-in `user`. Email first —
 * names collide and legacy rows carry "null" — then a cleaned name compare.
 */
export function isSameUser(user, target, targetEmail) {
    if (!user || !target) return false;
    const email = targetEmail || (typeof target === 'object' ? target.email : null);
    if (email && user.email) return email.toLowerCase() === user.email.toLowerCase();

    const name = displayName(target).toLowerCase();
    return !!name && name === displayName(user).toLowerCase();
}

/** Translation key for a history verb, switched to its second-person `…Self` form. */
export const selfKey = (key, isSelf) => (isSelf ? `${key}Self` : key);
